import { components } from '@apiSchema';
import http from '@core/fetch';
import { useData } from '@core/hooks/useData';
import { IMacDetails, mapMacDetails } from '@models/MacDetails';

type MacDetailResponse = components['schemas']['MacDetailResponse'];

const REQUEST_TYPE = 'mac details';

// getXHR rejects on network errors and non-2xx statuses (404 redirects to the 404 page),
// so a failed load ends in an error state instead of a request that never settles.
export async function getMacDetails(id: number): Promise<IMacDetails | null> {
    try {
        const response: MacDetailResponse | null = await http.getXHR(REQUEST_TYPE, { id });
        return response ? mapMacDetails(response, id) : null;
    } catch (err) {
        console.error('Fetch error:', REQUEST_TYPE, err);
        return null;
    }
}

export function useMacDetails(id: number) {
    return useData<IMacDetails | null>(null, getMacDetails, id);
}
